import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { ListLayout2 } from '@components/list/components/list-layout-2/model';
import { ResponsiveService } from '@services/responsive';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-list-layout-2',
  imports: [TitleComponent],
  templateUrl: './list-layout-2.component.html',
  styleUrl: './list-layout-2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListLayout2Component implements OnInit {
  readonly data = input.required<ListLayout2>();
  readonly breakpoints = inject(ResponsiveService).breakpoints;
  title = signal<Title>(null!);
  subtitle = signal<Title>(null!);
  items = signal<
    {
      title: Title;
      text: string;
    }[]
  >(null!);

  ngOnInit(): void {
    this.title.set({
      level: 'H3',
      size: {
        mobile: 'H2',
        desktop: 'H2',
      },
      color: 'BLACK',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      text: this.data().title,
    });
    this.subtitle.set({
      level: 'SPAN',
      type: 'SLASH',
      size: {
        mobile: 'SPAN',
        desktop: 'SPAN',
      },
      color: 'GREY_LIGHT',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      weight: 500,
      text: this.data().subtitle,
    });
    this.items.set(
      this.data().items.map((item) => ({
        ...item,
        title: {
          level: 'H4',
          type: 'NORMAL',
          size: {
            mobile: 'H4',
            desktop: 'H5',
          },
          font: 'INTER',
          weight: 500,

          color: 'BLACK',
          align: {
            mobile: 'LEFT',
            desktop: 'LEFT',
          },
          text: item.title,
        },
      }))
    );
  }
}
